<template>
  <div class="filter-button">
    <div class="basic-btn" @click="openKitchenDropdown()">
      <h6>{{ activeType }}</h6>
      <svg class="rightarrow" fill="none">
        <use xlink:href="#right-arrow-b" />
      </svg>
    </div>
    <div
      class="filter-content"
      :class="{ show: openKitchenTypes }"
      @mouseleave="mouseLeaveCloseKitchenTypes()"
    >
      <div class="content-header d-flex d-sm-none">
        <h6>{{ _T('food type') }}</h6>
        <a
          href="javascript:void(0)"
          class="close-filter"
          @click="closeKitchenTypes()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
              fill="#3D3F43"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="#3D3F43"
            ></path>
          </svg>
        </a>
      </div>
      <ul>
        <li
          :class="{ active: activeKitchenType == '' }"
          @click=";(activeKitchenType = ''), (activeType = _T('All Cuisine'))"
        >
          {{ _T('All Cuisine') }}
        </li>
        <li
          :class="{ active: activeKitchenType == kitchenType._id }"
          v-for="(kitchenType, key) in all_goorder_kitchen_types"
          :key="'module_' + key"
          @click="
            ;(activeKitchenType = kitchenType._id),
              (activeType = _T_DB(kitchenType, 'name'))
          "
        >
          {{ _T_DB(kitchenType, 'name') }}
        </li>
      </ul>
      <div class="apply-btn d-none d-sm-block">
        <a
          href="javascript:void(0)"
          @click="Apply(activeKitchenType)"
          class="btn btn-solid"
          >{{ _T('Apply') }}</a
        >
      </div>
      <div class="content-footer d-block d-sm-none">
        <a
          href="javascript:void(0)"
          class="btn btn-outline"
          @click="closeKitchenTypes()"
          >{{ _T('back') }}</a
        >
        <a
          href="javascript:void(0)"
          class="btn btn-solid ml-15"
          @click="Apply(activeKitchenType)"
          >{{ _T('Apply') }}</a
        >
      </div>
    </div>
    <div class="mobile-overlay" :class="{ show: openKitchenTypes }"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'

export default {
  name: 'KitchenTypes',
  mixins: [Windowsize],
  data() {
    return {
      openKitchenTypes: false,
      activeKitchenType: '',
      activeType: '',
    }
  },
  watch: {
    openKitchenTypes(newVal) {
      if (newVal) {
        document.body.style.setProperty('overflow', 'hidden')
      } else {
        document.body.style.removeProperty('overflow')
      }
    },
  },
  computed: {
    ...mapGetters(['_T', '_T_DB', 'all_goorder_kitchen_types']),
  },
  methods: {
    openKitchenDropdown() {
      this.openKitchenTypes = !this.openKitchenTypes
    },
    closeKitchenTypes() {
      this.openKitchenTypes = false
    },
    mouseLeaveCloseKitchenTypes() {
      if (this.windowSize > 575) {
        this.closeKitchenTypes()
      }
    },
    Apply(data) {
      this.$store.commit('SET_SELECTED_KITCHEN_TYPE', data)
      this.openKitchenTypes = false
    },
  },
  mounted() {
    this.activeType = this._T('All Cuisine');
  }
}
</script>
